// composables/useDialogStack.js
let zIndex = 1000;
let openCount = 0;

export function useDialogStack() {
  const currentZIndex = ++zIndex;

  // 增加打开计数
  openCount++;
  if (openCount === 1) {
    document.body.classList.add('tx-dialog-hidden');
  }

  // 返回清理函数
  const dispose = () => {
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) {
      document.body.classList.remove('tx-dialog-hidden');
    }
  };

  return {
    zIndex: currentZIndex,
    dispose,
  };
}